/**
 * Ensures images site-wide use lazy loading except LCP candidates,
 * and always have alt, width, and height attributes when possible.
 */
(() => {
  const LCP_SELECTOR = 'img.js-lcp-image, img[data-lcp="true"], [data-lcp="true"] img';

  const isLcpImage = (img) => {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.classList.contains('js-lcp-image') || img.dataset.lcp === 'true') return true;
    return Boolean(img.closest('[data-lcp="true"]'));
  };

  const optimizeImage = (img) => {
    if (!img || img.tagName !== 'IMG') return;

    const lcp = isLcpImage(img);

    if (!img.hasAttribute('loading')) {
      img.loading = lcp ? 'eager' : 'lazy';
    } else if (!lcp && img.getAttribute('loading') !== 'lazy') {
      img.loading = 'lazy';
    }

    if (lcp && !img.hasAttribute('fetchpriority')) {
      img.setAttribute('fetchpriority', 'high');
    }

    if (!img.hasAttribute('decoding')) {
      img.decoding = lcp ? 'sync' : 'async';
    }

    if (!img.hasAttribute('alt')) {
      img.setAttribute('alt', '');
    }

    if (!img.hasAttribute('width') || img.getAttribute('width') === 'auto') {
      const width = img.getAttribute('data-width') || img.dataset.width;
      if (width) img.setAttribute('width', width);
    }

    if (!img.hasAttribute('height') || img.getAttribute('height') === 'auto') {
      const height = img.getAttribute('data-height') || img.dataset.height;
      if (height) img.setAttribute('height', height);
    }
  };

  const scan = (root = document) => {
    root.querySelectorAll('img').forEach(optimizeImage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'IMG') optimizeImage(node);
        scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
